import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'

Alpine.plugin(focus)

window.Alpine = Alpine

Alpine.start()

document.querySelectorAll('[loading="lazy"]').forEach(element => {
  const animateIn = () => {
    element.style.opacity = 1;
  };

  if (element.complete) {
    animateIn();
  } else {
    element.addEventListener('load', animateIn);
  }
});
